export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8354.9d300f4f.jpg";